import React from "react";
import { Polyline } from "react-leaflet";

// линии между Wi-Fi и  switch
const WifiSwitchLines = ({ item, switches }) => {
  return (
    <>
      {switches.map((sw, si) => {
        if (
          sw.wifiId === item.id &&
          sw.latitude !== undefined &&
          sw.longitude !== undefined &&
          item.latitude !== undefined &&
          item.longitude !== undefined
        ) {
          return (
            <Polyline
              key={`wifi-switch-${item.id}-${si}`}
              positions={[
                [item.latitude, item.longitude],
                [sw.latitude, sw.longitude],
              ]}
              color="blue"
            />
          );
        }
        return null;
      })}
    </>
  );
};

export default WifiSwitchLines;